import { render, staticRenderFns } from "./GenericInsuranceDocumentType.vue?vue&type=template&id=22a2270a"
import script from "./GenericInsuranceDocumentType.vue?vue&type=script&lang=js"
export * from "./GenericInsuranceDocumentType.vue?vue&type=script&lang=js"
import style0 from "./GenericInsuranceDocumentType.vue?vue&type=style&index=0&id=22a2270a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports